import {Module, Tracking2} from '@mamdev/cad.static-next-lib';
import type {StateReplacedData} from '../../ts/services/history';
import {html, render} from 'lit';

export default class BreadcrumbTop extends Module {
  isFirstRender = true;

  constructor(root: HTMLElement) {
    super(root);

    this.name_ = 'breadcrumb-top';
  }

  static attachTo(root: HTMLElement): BreadcrumbTop {
    return new BreadcrumbTop(root);
  }

  start() {
    this.log('start');

    this.subscribe('history:stateReplaced', data => {
      const stateData = data as StateReplacedData;

      // this.log(stateData.url);
      // console.log('[breadcrumb-top]', stateData.state);

      if (this.isFirstRender) {
        this.root_.innerHTML = '';
        this.isFirstRender = false;
      }

      render(this.renderTemplate(stateData.state.headcrumb), this.root_);

      this.publish('general:newContent', this.root_);
      Tracking2.bindTrackingClickHandler(this.root_.querySelectorAll('[data-component-path]'));
    });
  }

  private renderTemplate(headcrumbParts: {brainZone: string; componentPath: string; name: string; url: string}[]) {
    return html`
      <ul class="breadcrumb__top__list">
        ${headcrumbParts.map((part, index) => html`
          <li>
            ${index === 0
                ? html`<a href="${part.url}" data-brain-zone="${part.brainZone}" data-component-path="${part.componentPath}" class="icon-svg-home-breadcrumb" aria-label="Startseite"></a>`
                : html`<a href="${part.url}" data-brain-zone="${part.brainZone}" data-component-path="${part.componentPath}">${part.name}</a>`
            }
          </li>

          ${index < headcrumbParts.length - 1 ? this.renderSeparator() : null}
        `)}
      </ul>
    `;
  }

  private renderSeparator() {
    return html`
      <li class="separator">
        <span class="icon-svg-arrow-right-breadcrumb"></span>
      </li>
    `;
  }
}
